import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useAndReportExperimentTreatment } from '../experiments';
import { useCurrentSessionUser } from '../session';

type UseCanConfigureMTOPolicyAdminPageSettings = () => boolean;
export const useCanConfigureMTOPolicyAdminPageSettings: UseCanConfigureMTOPolicyAdminPageSettings = () => {
  const { isNetworkAdmin } = useCurrentSessionUser();
  const isMTOPolicyAdminPageExperimentEnabled =
    useAndReportExperimentTreatment(Experiment.MTOPolicyEngageAdminPortalPage) === true;

  return isNetworkAdmin && isMTOPolicyAdminPageExperimentEnabled;
};
